import React from 'react';
import './ChartTooltip.css';

// formatValue(value, name, datum) — datum is the chart row (e.g. a pie segment with extra fields).
// details(datum) → string[] (optional): extra lines below a row, e.g. the channel split of an add-on's income.
export function ChartTooltip({ active, payload, label, formatValue, details }) {
  if (!active || !payload?.length) return null;
  return (
    <div className="chartTooltip">
      {label && <p className="chartTooltipLabel">{label}</p>}
      <div className="chartTooltipRows">
        {payload.map((entry, i) => {
          const lines = details ? (details(entry.payload) ?? []).filter(Boolean) : [];
          return (
            <React.Fragment key={i}>
              <div className="chartTooltipRow">
                <span className="chartTooltipDot" style={{ background: entry.color || entry.fill }} />
                <span className="chartTooltipName">{entry.name}</span>
                <span className="chartTooltipValue">
                  {formatValue ? formatValue(entry.value, entry.name, entry.payload) : entry.value}
                </span>
              </div>
              {lines.map((line, j) => (
                <span key={j} className="chartTooltipDetail">{line}</span>
              ))}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
